// ─────────────────────────────────────────────────────────────────────
// Barebones Thailand — shipping seed (canonical = docs/seed-shipping.json)
// domestic = ประกาศไปรษณีย์ไทย 2568 · intl z1–z5 = ค่าประมาณ (ตรวจจริงก่อน go-live)
// เมื่อ DB live: store.shipping_rate / shipping_country / setting เป็นตัวจริง
// ไฟล์นี้เป็น fallback + ต้นทาง seed SQL เท่านั้น
// ─────────────────────────────────────────────────────────────────────
export const ZONES = [
  { code: 'dom', label: 'ในประเทศ' },
  { code: 'z1', label: 'อาเซียนใกล้' },
  { code: 'z2', label: 'เอเชียตะวันออก' },
  { code: 'z3', label: 'เอเชียใต้/ตะวันออกกลาง/โอเชียเนีย' },
  { code: 'z4', label: 'ยุโรป/อเมริกาเหนือ' },
  { code: 'z5', label: 'อื่นๆ ทั่วโลก' },
];

// [iso2, name_th, zone]
export const COUNTRIES = [
  ['TH', 'ไทย (ในประเทศ)', 'dom'],
  ['LA', 'ลาว', 'z1'], ['MM', 'เมียนมา', 'z1'], ['KH', 'กัมพูชา', 'z1'],
  ['VN', 'เวียดนาม', 'z1'], ['MY', 'มาเลเซีย', 'z1'], ['SG', 'สิงคโปร์', 'z1'],
  ['CN', 'จีน', 'z2'], ['HK', 'ฮ่องกง', 'z2'], ['TW', 'ไต้หวัน', 'z2'],
  ['JP', 'ญี่ปุ่น', 'z2'], ['KR', 'เกาหลีใต้', 'z2'], ['ID', 'อินโดนีเซีย', 'z2'], ['PH', 'ฟิลิปปินส์', 'z2'],
  ['IN', 'อินเดีย', 'z3'], ['AE', 'สหรัฐอาหรับเอมิเรตส์', 'z3'], ['AU', 'ออสเตรเลีย', 'z3'], ['NZ', 'นิวซีแลนด์', 'z3'],
  ['GB', 'สหราชอาณาจักร', 'z4'], ['DE', 'เยอรมนี', 'z4'], ['FR', 'ฝรั่งเศส', 'z4'],
  ['NL', 'เนเธอร์แลนด์', 'z4'], ['US', 'สหรัฐอเมริกา', 'z4'], ['CA', 'แคนาดา', 'z4'],
  ['BR', 'บราซิล', 'z5'], ['ZA', 'แอฟริกาใต้', 'z5'], ['OTHER', 'ประเทศอื่นๆ', 'z5'],
];

// band rows เหมือน store.shipping_rate: weight<=max_g → price_thb;
// is_overflow=true → +price_thb ต่อ step_g เมื่อเกิน band สูงสุด
export const RATES = [
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 20, price_thb: 32, is_overflow: false, sort: 1 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 100, price_thb: 37, is_overflow: false, sort: 2 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 250, price_thb: 42, is_overflow: false, sort: 3 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 500, price_thb: 52, is_overflow: false, sort: 4 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 1000, price_thb: 67, is_overflow: false, sort: 5 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 1500, price_thb: 82, is_overflow: false, sort: 6 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: 2000, price_thb: 97, is_overflow: false, sort: 7 },
  { zone_code: 'dom', method: 'ems', method_label: 'ไปรษณีย์ไทย EMS', eta: 'ด่วนพิเศษ · 1–2 วันทำการ', max_g: null, price_thb: 15, step_g: 500, is_overflow: true, sort: 8 },

  { zone_code: 'dom', method: 'eco', method_label: 'พัสดุลงทะเบียน', eta: 'ประหยัด · 3–5 วันทำการ', max_g: 1000, price_thb: 25, is_overflow: false, sort: 1 },
  { zone_code: 'dom', method: 'eco', method_label: 'พัสดุลงทะเบียน', eta: 'ประหยัด · 3–5 วันทำการ', max_g: null, price_thb: 12, step_g: 1000, is_overflow: true, sort: 2 },

  { zone_code: 'z1', method: 'ems-intl', method_label: 'EMS World', eta: 'อาเซียนใกล้ · 5–14 วันทำการ', max_g: 500, price_thb: 660, is_overflow: false, sort: 1 },
  { zone_code: 'z1', method: 'ems-intl', method_label: 'EMS World', eta: 'อาเซียนใกล้ · 5–14 วันทำการ', max_g: null, price_thb: 90, step_g: 500, is_overflow: true, sort: 2 },
  { zone_code: 'z2', method: 'ems-intl', method_label: 'EMS World', eta: 'เอเชียตะวันออก · 5–14 วันทำการ', max_g: 500, price_thb: 780, is_overflow: false, sort: 1 },
  { zone_code: 'z2', method: 'ems-intl', method_label: 'EMS World', eta: 'เอเชียตะวันออก · 5–14 วันทำการ', max_g: null, price_thb: 120, step_g: 500, is_overflow: true, sort: 2 },
  { zone_code: 'z3', method: 'ems-intl', method_label: 'EMS World', eta: 'เอเชียใต้/ตะวันออกกลาง/โอเชียเนีย · 5–14 วันทำการ', max_g: 500, price_thb: 900, is_overflow: false, sort: 1 },
  { zone_code: 'z3', method: 'ems-intl', method_label: 'EMS World', eta: 'เอเชียใต้/ตะวันออกกลาง/โอเชียเนีย · 5–14 วันทำการ', max_g: null, price_thb: 150, step_g: 500, is_overflow: true, sort: 2 },
  { zone_code: 'z4', method: 'ems-intl', method_label: 'EMS World', eta: 'ยุโรป/อเมริกาเหนือ · 5–14 วันทำการ', max_g: 500, price_thb: 1100, is_overflow: false, sort: 1 },
  { zone_code: 'z4', method: 'ems-intl', method_label: 'EMS World', eta: 'ยุโรป/อเมริกาเหนือ · 5–14 วันทำการ', max_g: null, price_thb: 200, step_g: 500, is_overflow: true, sort: 2 },
  { zone_code: 'z5', method: 'ems-intl', method_label: 'EMS World', eta: 'ทั่วโลก · 7–21 วันทำการ', max_g: 500, price_thb: 1300, is_overflow: false, sort: 1 },
  { zone_code: 'z5', method: 'ems-intl', method_label: 'EMS World', eta: 'ทั่วโลก · 7–21 วันทำการ', max_g: null, price_thb: 260, step_g: 500, is_overflow: true, sort: 2 },
];

export const CAPS = { dom_max_g: 20000, intl_max_g: 30000 };

// internal — ลูกค้าเห็นแค่ "ค่าจัดส่ง" ก้อนเดียว (decision #4 ใน handoff)
export const SETTINGS = {
  pack_material_grams: 150,
  pack_handling_fee: 10,
  free_ship_threshold: 2000,
};

export const zoneOf = (iso2) =>
  (COUNTRIES.find((c) => c[0] === iso2) || ['', '', 'z5'])[2];
